export const FeatureTier = ({ number, title, lede, bullets, highlight = false }) => (
  <div className={`feature-tier${highlight ? " highlight" : ""}`}>
    <div>
      <div className="feature-tier-num">Tier {number}</div>
      <h3>{title}</h3>
      <p className="feature-tier-lede">{lede}</p>
    </div>
    <ul className="feature-tier-list">
      {bullets.map((b, i) => (
        <li key={i}>
          {b.title ? <strong>{b.title}</strong> : null}
          {b.text}
        </li>
      ))}
    </ul>
  </div>
);
